<template>
  <v-container>
    <h2 class="text-center my-12">{{ $t("aiartimpostor.title") }}</h2>
    <v-card class="mx-auto my-8" elevation="4" max-width="900">
      <v-img :src="aiaiHeader" cover></v-img>
      <!-- <v-card-item>
        <v-card-title>
        </v-card-title>
        <v-card-subtitle>
        </v-card-subtitle>
      </v-card-item>
      <v-card-text>
      </v-card-text> -->

      <v-container>
        <v-form ref="form">
        <p class="text-label-large">お問い合わせ内容<span class="text-red ml-2">※{{ $t("app.required") }}</span></p>
        <v-select placeholder="選択してください" max-width="300" :rules="[requiredValidation]" v-model="inputType"
          :items="[
            { title: 'バグ報告', value: 'bug' },
            { title: '仕様改善/フィードバック', value: 'feedback' },
            { title: '新規実装/アイデア', value: 'idea' },
          ]"></v-select>
        <p class="text-label-large">発生箇所<span class="text-red ml-2">※{{ $t("app.required") }}</span></p>
        <v-select placeholder="選択してください" max-width="300" :rules="[requiredValidation]" v-model="inputKind"
          :items="[
            { title: 'レートマッチ', value: 'rate' },
            { title: 'プライベートマッチ', value: 'private' },
            { title: 'その他', value: 'others' },
          ]"></v-select>
        <p class="text-label-large">プラットフォーム<span class="text-red ml-2">※{{ $t("app.required") }}</span></p>
        <v-select placeholder="選択してください" max-width="300" :rules="[requiredValidation]" v-model="inputPlatform"
          :items="[
            { title: 'Steam', value: 'steam' },
            { title: 'Android', value: 'android' },
            { title: 'iOS', value: 'ios' },
          ]"></v-select>
        <p class="text-label-large">概要<span class="text-red ml-2">※{{ $t("app.required") }}</span></p>
        <v-text-field placeholder="入力してください" :rules="[requiredValidation]" v-model="inputTitle"></v-text-field>
        <p class="text-label-large">詳細<span class="text-red ml-2">※{{ $t("app.required") }}</span></p>
        <v-textarea placeholder="入力してください" :rules="[requiredValidation]" v-model="inputDescription"></v-textarea>
        <p class="text-label-large">バージョン</p>
        <v-text-field placeholder="不明な場合は空欄で構いません" v-model="inputVersion"></v-text-field>
        <p class="text-label-large">スクリーンショットなど</p>
        <v-file-input label="最大3枚/合計10MBまで添付可能" :prepend-icon="mdiImage" counter multiple show-size
          accept="image/*, video/*" :rules="[fileInputValidation]" v-model="inputFiles"></v-file-input>
        <p class="text-label-large">連絡先</p>
        <v-text-field placeholder=" E-mailまたはX,Discord ID" v-model="inputContact"></v-text-field>

        </v-form>

        <v-progress-linear indeterminate color="cyan" v-if="isSubmitting"></v-progress-linear>
        <v-btn elevated color="cyan" class="mt-4 ml-auto d-block" :loading="isSubmitting" @click="submitForm">
          送信
        </v-btn>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import aiaiHeader from "@/assets/img/header_aiai.jpg";
import { mdiImage } from '@mdi/js'

export default {
  name: 'AiArtImpostorView',
  data() {
    return {
      aiaiHeader,
      mdiImage,
      inputType: null,
      inputKind: null,
      inputPlatform: null,
      inputTitle: null,
      inputDescription: null,
      inputVersion: null,
      inputContact: null,
      inputFiles: [],
      paramDeviceId: null,
      paramSessionId: null,
      paramNetwork: null,
      paramLog: null,
      isSubmitting: false,
    }
  },
  mounted() {
    const params = new URLSearchParams(window.location.search)
    this.inputType = params.get('type')
    this.inputKind = params.get('kind')
    this.inputPlatform = params.get('platform')
    this.inputVersion = params.get('version')
    this.paramDeviceId = params.get('deviceId')
    this.paramSessionId = params.get('sessionId')
    this.paramNetwork = params.get('iscareer')
    this.paramLog = params.get('log')
  },
  methods: {
    requiredValidation(value) {
      return !!value || '必ず入力してください'
    },
    fileInputValidation(value) {
      if (!value || value.length === 0) return true
      const invalidFile = value.find((file) => !file.type.startsWith('image/') && !file.type.startsWith('video/'))
      if (invalidFile) return `"${invalidFile.name}" は画像または動画ファイルではありません`
      if (value.length > 3) return '最大3枚まで添付可能です'
      const totalSize = value.reduce((acc, file) => acc + file.size, 0)
      if (totalSize > 10 * 1024 * 1024) return '合計10MBを超えています'
      return true
    },
    async submitForm() {
      const { valid } = await this.$refs.form.validate()
      if (!valid) return

      this.isSubmitting = true

      const formData = new FormData()
      formData.append('type', this.inputType || '')
      formData.append('kind', this.inputKind || '')
      formData.append('platform', this.inputPlatform || '')
      formData.append('title', this.inputTitle || '')
      formData.append('description', this.inputDescription || '')
      formData.append('version', this.inputVersion || '')
      formData.append('deviceId', this.paramDeviceId || '')
      formData.append('sessionId', this.paramSessionId || '')
      formData.append('contact', this.inputContact || '')
      formData.append('network', this.paramNetwork || '')
      formData.append('log', this.paramLog || '')

      if (this.inputFiles) {
        this.inputFiles.forEach((file) => {
          formData.append('screenshots', file)
        })
      }

      fetch('https://pocketpair-forms-api-dot-pocketpair.an.r.appspot.com/v1/api/form/aiai', {
        method: 'POST',
        body: formData,
      }).then((res) => {
        if (res.status === 200) {
          this.$router.push('/submitted')
        } else {
          console.log(res.status)
        }
      }).catch((err) => {
        console.error(err)
      }).finally(() => {
        this.isSubmitting = false
      })
    }
  }
}
</script>
